webpackJsonp([35783957827783],{

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(2);
	
	var emptyObject = __webpack_require__(40);
	var _invariant = __webpack_require__(1);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stats = __webpack_require__(192);
	
	var _stats2 = _interopRequireDefault(_stats);
	
	var _utils = __webpack_require__(157);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PypiStats = function PypiStats(_ref) {
	  var children = _ref.children;
	
	  // Only accept name as h4 element of children
	  var name = children.filter(function (node) {
	    return node.type === 'h4';
	  })[0].props.children;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    children,
	    _react2.default.createElement(
	      'div',
	      { className: 'stats' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Downloads:'
	        ),
	        ' ',
	        _react2.default.createElement(
	          'span',
	          null,
	          _stats2.default[name] ? (0, _utils.format_number)(_stats2.default[name].downloads) : ''
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Releases:'
	        ),
	        ' ',
	        _react2.default.createElement(
	          'span',
	          null,
	          _stats2.default[name] ? _stats2.default[name].releases : ''
	        )
	      )
	    )
	  );
	};
	exports.default = PypiStats;
	module.exports = exports['default'];

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(186);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _pypi = __webpack_require__(256);
	
	var _pypi2 = _interopRequireDefault(_pypi);
	
	var _stats = __webpack_require__(192);
	
	var _stats2 = _interopRequireDefault(_stats);
	
	var _utils = __webpack_require__(157);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'contributions' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Open Source contributions by kitconcept GmbH.'
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Total releases per person'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'contrib-person' },
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Timo Stollenwerk:'
	        ),
	        ' ',
	        _react2.default.createElement(
	          'span',
	          null,
	          _stats2.default.timo_releases
	        )
	      ),
	      ' ',
	      _react2.default.createElement(
	        'p',
	        { className: 'contrib-person' },
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Victor Fern\xE1ndez de Alba:'
	        ),
	        ' ',
	        _react2.default.createElement(
	          'span',
	          null,
	          _stats2.default.victor_releases
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'contrib-person' },
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Carsten Senger:'
	        ),
	        ' ',
	        _react2.default.createElement(
	          'span',
	          null,
	          _stats2.default.carsten_releases
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'contrib-person' },
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Roel Bruggink:'
	        ),
	        ' ',
	        _react2.default.createElement(
	          'span',
	          null,
	          _stats2.default.roel_releases
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Total downloads'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'contrib-person' },
	        _react2.default.createElement(
	          'strong',
	          null,
	          'kitconcept GmbH:'
	        ),
	        ' ',
	        _react2.default.createElement(
	          'span',
	          null,
	          (0, _utils.format_number)(_stats2.default.total_downloads)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Plone Core'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'plonetheme.barceloneta'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Standard-Theme for Plone 5.'
	          ),
	          _react2.default.createElement(
	            'h6',
	            null,
	            'Co-author: Victor Fernandez de Alba'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'plone.restapi'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'RESTful API for Plone.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Ships with Plone 5.2'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('a', { href: 'https://pypi.python.org/pypi/plone.restapi' })
	          ),
	          _react2.default.createElement(
	            'h6',
	            null,
	            'Main author: Timo Stollenwerk'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'plone.rest'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Plone support for HTTP verbs.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Ships with Plone 5.2.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://pypi.python.org/pypi/plone.rest' },
	              'Pypi Link'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'plone.app.contenttypes'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Default content types for Plone based on Dexterity.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Ships with Plone since 4.3'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://pypi.python.org/pypi/plone.app.contenttypes' },
	              'Pypi Link'
	            )
	          ),
	          _react2.default.createElement(
	            'h6',
	            null,
	            'Co author: Timo Stollenwerk'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'plone.app.collection'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'This package adds \'saved search\' functionality to Plone.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'plone.app.discussion'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Enhanced discussion support for Plone.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'plone.app.multilingual'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Multilingual Plone UI package, enables maintenance of translations for both Dexterity types and Archetypes.'
	          ),
	          _react2.default.createElement(
	            'h6',
	            null,
	            'Co-author: Victor Fernandez de Alba'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'plone.api'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'A Plone API.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Products.TinyMCE'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Adds support for TinyMCE, a platform independent web based Javascript HTML WYSIWYG editor, to Plone.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Plone Add-on Products'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'plone.formwidget.captcha'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Captcha widget for Plone..'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'plone.formwidget.recaptcha'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'ReCaptcha widget for Plone..'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'collective.akismet'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Akismet plugin for plone.app.discussion.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'collective.mailchimp'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'MailChimp integration for Plone.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'collective.disableuser'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Blocks login for specified users.'
	          ),
	          _react2.default.createElement(
	            'h6',
	            null,
	            'Main author: Roel Bruggink'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'upc.remotecontrol'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'upc.remotecontrol is a tool for managing a set of Plone instances through XML- RPC calls.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'collective.cas4plone'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'A PAS plugin that authenticates users against a CAS (Central Authentication Service) server.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'bobtemplates.kitconcept'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'kitconcept curated templates for Plone projects.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'collective.autoresizetextarea'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'jQuery textarea auto-resizer for Plone.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'collective.solr'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Solr integration for external indexing and searching.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'collective.lesscss'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'This package allow theme developers to add LESS stylesheets into a Plone site.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'collective.pantry'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'An add-on for Plone that allows you to enhance the user experience on reusable templates on TinyMCE and Mosaic.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'collective.geotransform'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Gracefully email obfuscation for Plone.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'collective.js.formvalidation'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'jQuery-based client-side form validation, based on http://bassistance.de/jquery-plugins/jquery-plugin-validation/.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'collective.portlet.recentactivity'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Recent activity portlet for Plone.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'collective.contentrules.mailtolocalrole'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Send e-mail to users having a localrole on the object.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'collective.z3cform.datetimewidget'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'z3c.form date and datetime widgets.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'js.jquery_joyride'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Fanstatic packaging of joyride.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'js.socialshareprivacy'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Fanstatic packaging of jquery.socialshareprivacy.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Products.Marshall'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Configurable Marshallers for Archetypes.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'sphinxcontrib-httpexample'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Adds example directive for sphinx-contrib httpdomain.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'wicked'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            ' ',
	            'wicked is a compact syntax for doing wiki-like content linking and creation in zope and plone.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'plone.app.changeownership'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Change Plone objects ownership.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'collective.multilanguagefields'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Multi language fields for Plone.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'fourdigits.seo'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Package for SEO.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'collective.classifieds'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Add classifieds to your Plone intranet or website.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'iw.rejectanonymous'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Disallow access to a Plone site and its children if user is anonymous.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'collective.alias'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Aliasing of Plone content.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'fourdigits.portlet.keywordrelated'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'A portlet showing related items, based on the current contexts tags.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'fourdigits.remotemembrane'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'A set of PAS plugins so users are authenticated from another Plone site.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Products.Faq'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'FAQ - An AT contenttype for Plone.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'collective.ploneslimbar'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'slimbar for listing local communities sites.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Products.PloneSoftwareCenter'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'PloneSoftwareCenter is a tool that keeps track of software projects.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'collective.anonymousview'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Allow a loggedin user to view a page as an anonymous user.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'fourdigits.chosen'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Integrates the Chosen javascript library in Plone.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'package' },
	        _react2.default.createElement(
	          _pypi2.default,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'collective.ordereddict'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Ordered Dictionary for Python 2.4 or later.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Plone Themes'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'plonetheme.mimbo'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'plonetheme.solemnity'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'plonetheme.stylized'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'plonetheme.sunburst'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Robot Framework'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'package' },
	          _react2.default.createElement(
	            _pypi2.default,
	            null,
	            _react2.default.createElement(
	              'h4',
	              null,
	              'robotframework-djangolibrary'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'A robot framework library for Django.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'package' },
	          _react2.default.createElement(
	            _pypi2.default,
	            null,
	            _react2.default.createElement(
	              'h4',
	              null,
	              'robotframework-react'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'A robot framework library for React.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'package' },
	          _react2.default.createElement(
	            _pypi2.default,
	            null,
	            _react2.default.createElement(
	              'h4',
	              null,
	              'robotframework-webpack'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'A robot framework library for Webpack.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Django'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'package' },
	          _react2.default.createElement(
	            _pypi2.default,
	            null,
	            _react2.default.createElement(
	              'h4',
	              null,
	              'robotframework-djangolibrary'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'A robot framework library for Django.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          'React'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'package' },
	          _react2.default.createElement(
	            _pypi2.default,
	            null,
	            _react2.default.createElement(
	              'h4',
	              null,
	              'robotframework-react'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'A robot framework library for React.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Solr'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'package' },
	          _react2.default.createElement(
	            _pypi2.default,
	            null,
	            _react2.default.createElement(
	              'h4',
	              null,
	              'pytest-solr'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Solr process and client fixtures for py.test.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Jenkins'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'package' },
	          _react2.default.createElement(
	            _pypi2.default,
	            null,
	            _react2.default.createElement(
	              'h4',
	              null,
	              'plone.recipe.codeanalysis'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Static code analysis for buildout-based Python projects.'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 192:
/***/ (function(module, exports) {

	module.exports = {"iw.rejectanonymous":{"downloads":24697,"releases":9},"collective.alias":{"downloads":15869,"releases":6},"collective.pantry":{"downloads":0,"releases":1},"collective.lesscss":{"downloads":12395,"releases":8},"plone.formwidget.recaptcha":{"downloads":19699,"releases":7},"victor_releases":108,"Products.PloneSoftwareCenter":{"downloads":33893,"releases":9},"plonetheme.solemnity":{"downloads":9090,"releases":3},"upc.remotecontrol":{"downloads":3260,"releases":1},"plone.app.collection":{"downloads":145549,"releases":37},"plone.formwidget.captcha":{"downloads":26242,"releases":8},"bobtemplates.kitconcept":{"downloads":0,"releases":2},"collective.akismet":{"downloads":12739,"releases":4},"collective.autoresizetextarea":{"downloads":10333,"releases":3},"collective.portlet.recentactivity":{"downloads":22073,"releases":7},"plonetheme.barceloneta":{"downloads":29954,"releases":32},"plone.app.multilingual":{"downloads":65772,"releases":58},"total_downloads":2832155,"timo_releases":462,"plonetheme.sunburst":{"downloads":250970,"releases":50},"carsten_releases":83,"fourdigits.chosen":{"downloads":11072,"releases":4},"collective.js.formvalidation":{"downloads":6333,"releases":2},"Products.Faq":{"downloads":14483,"releases":5},"collective.solr":{"downloads":172168,"releases":58},"collective.mailchimp":{"downloads":31394,"releases":18},"wicked":{"downloads":229574,"releases":15},"collective.multilanguagefields":{"downloads":7377,"releases":6},"js.jquery_joyride":{"downloads":8080,"releases":2},"collective.contentrules.mailtolocalrole":{"downloads":19735,"releases":6},"Products.TinyMCE":{"downloads":432900,"releases":94},"collective.geotransform":{"downloads":9492,"releases":6},"sphinxcontrib-httpexample":{"downloads":154,"releases":14},"fourdigits.seo":{"downloads":2205,"releases":1},"collective.cas4plone":{"downloads":9925,"releases":3},"plone.app.changeownership":{"downloads":12292,"releases":5},"collective.classifieds":{"downloads":98305,"releases":30},"fourdigits.portlet.keywordrelated":{"downloads":6376,"releases":3},"plone.app.contenttypes":{"downloads":75664,"releases":68},"robotframework-webpack":{"downloads":2143,"releases":11},"plonetheme.mimbo":{"downloads":12685,"releases":4},"plonetheme.stylized":{"downloads":15057,"releases":5},"Products.Marshall":{"downloads":171445,"releases":14},"plone.app.discussion":{"downloads":350100,"releases":106},"plone.rest":{"downloads":3302,"releases":9},"collective.ordereddict":{"downloads":3821,"releases":1},"collective.z3cform.datetimewidget":{"downloads":229468,"releases":27},"collective.disableuser":{"downloads":0,"releases":1},"plone.restapi":{"downloads":1523,"releases":28},"roel_releases":219,"robotframework-djangolibrary":{"downloads":4518,"releases":10},"js.socialshareprivacy":{"downloads":13995,"releases":5},"collective.ploneslimbar":{"downloads":5740,"releases":2},"plone.recipe.codeanalysis":{"downloads":64535,"releases":22},"plone.api":{"downloads":92696,"releases":35},"fourdigits.remotemembrane":{"downloads":8223,"releases":5},"pytest-solr":{"downloads":0,"releases":1},"collective.anonymousview":{"downloads":10101,"releases":3}}

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.format_number = undefined;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var format_number = function format_number(number) {
	  if (typeof window !== 'undefined' && typeof window.navigator !== 'undefined') {
	    return number.toLocaleString(navigator.language, {
	      minimumFractionDigits: 0
	    });
	  }
	  return number;
	};
	
	exports.format_number = format_number;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-7a0e1f43f921e2f0a7eb.js